import { z } from "zod";
import type { ImageDescription } from "./generatePhotoDescription";
import { requestBackend } from "./client";

const ArticleTitleResponseSchema = z.object({
  title: z.string().max(200).describe("Article title in plain text"),
});

export async function generateArticleTitle(
  descriptions: ImageDescription[],
  signal?: AbortSignal,
): Promise<string> {
  const response = await requestBackend("/articleTitle", {
    body: {
      sections: descriptions.map((description) => ({
        title: description.title,
        caption: description.caption || undefined,
        description: description.description,
        location_name: description.location_name,
        date: description.date,
      })),
    },
    responseSchema: ArticleTitleResponseSchema,
    signal,
  });

  return response.title;
}
